import type {
	AutomaticSourcesMode,
	PreviousStepDocumentsMode,
	WorkflowStepInputsPayload,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * What a document receives as input. Document types are exposed as bare ids, ready to be sent back
 * to the save endpoint.
 */
class WorkflowStepInputsView {
	readonly preparationElements: boolean;
	readonly previousStepDocumentsMode: PreviousStepDocumentsMode;
	readonly previousStepDocumentTypeIds: readonly number[];
	readonly automaticSourcesMode: AutomaticSourcesMode;
	readonly automaticSourceDocumentTypeIds: readonly number[];

	constructor(payload: WorkflowStepInputsPayload) {
		this.preparationElements = payload.preparationElements;
		this.previousStepDocumentsMode = payload.previousStepDocumentsMode;
		this.previousStepDocumentTypeIds = payload.previousStepDocumentTypes.map((type) => type.id);
		this.automaticSourcesMode = payload.automaticSourcesMode;
		this.automaticSourceDocumentTypeIds = payload.automaticSourceDocumentTypes.map((type) => type.id);

		Object.freeze(this);
	}
}

export default WorkflowStepInputsView;
